import { programResponseSchema } from '@academy/shared';
import { offlineStore } from '../offline/offline-store.js';
import { api, ApiError } from './client.js';

/**
 * Endpoint del programa público.
 *
 * Es la única llamada de la aplicación que NO necesita sesión, y por eso lleva
 * su propio módulo en vez de colarse en `lessons.js`: dejar claro en el código
 * qué se puede ver sin cuenta y qué no. Aquí se ve el temario; el contenido de
 * las lecciones y el progreso, no.
 *
 * La respuesta es idéntica para todo el mundo. Eso la hace cacheable, y de ahí
 * que el backend no la personalize nunca.
 */

/** @typedef {import('@academy/shared').ProgramResponse} Programa */

export const programApi = {
  /**
   * @returns {Promise<Programa>}
   */
  programa: async () => {
    try {
      const respuesta = api.datosDe(await api.programa());
      const parsed = programResponseSchema.safeParse(respuesta);

      if (!parsed.success) {
        console.warn(
          'La respuesta del servidor no encaja con el contrato del programa',
          parsed.error.issues,
        );
        throw new ApiError({
          code: 'INTERNAL_ERROR',
          status: 502,
          message: 'El servidor ha devuelto un programa con un formato inesperado',
        });
      }

      return parsed.data;
    } catch (error) {
      if (error instanceof ApiError && error.status === 0) {
        return offlineStore.getPrograma();
      }
      throw error;
    }
  },
};
